import React from 'react';
import {paths} from '../../common/dictionaries/urls';
import TechniciansGroups from './techniciansGroups/index';
import Technicians from './technicians/index';

export const technicianGroupRoutes = [
  {'component': <TechniciansGroups />, 'path': paths.TechniciansGroups},
  {'component': <Technicians />, 'path': paths.Technicians},
];
